<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
      </v-overlay>

      <v-row class="pa-2" no-gutters>
        <custom-popup
          v-model="ready"
          :cons="{ title: $t('popup.prepared_stores_title') }"
          hide-confirm
          hide-overlay
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <v-card class="p-5" flat>
            <prepared-cards
              :value="cardTexts"
              type="bShop"
              @closeModel="ready = false"
              @input="savePageTemplate"
            />
          </v-card>
        </custom-popup>

        <v-col class="pa-2 mb-4 sticky-md" cols="12" md="4" style="top: 12px">
          <v-tabs
            v-model="qrShow"
            background-color="grey lighten-3 pa-1"
            class="rounded-pill mx-auto pa-1"
            color="primary"
            height="48"
            style="width: fit-content"
          >
            <v-tab :disabled="e6 <= 1" :ripple="true">{{
              $t("tabs.qr_view")
            }}</v-tab>
            <v-tab :ripple="true">{{ $t("tabs.preview") }}</v-tab>
            <v-tab :ripple="true" :disabled="e6 <= 1">تعرفه‌ها</v-tab>
          </v-tabs>
        </v-col>

        <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 110px; height: fit-content"
        >
          <v-tabs-items
            v-model="qrShow"
            class="overflow-visible mb-4 mb-md-0"
            touchless
          >
            <v-tab-item>
              <qr-maker :loading="loading"  />
              <v-btn class="btn-download" @click="showDialog = true">
                <v-icon>mdi-progress-download</v-icon>
                {{ $t("buttons.download_qr") }}
              </v-btn>
            </v-tab-item>

            <v-tab-item>
              <view-shop v-model="cardTexts" :isCleared="isCleared" :qr-svg-data-url="qrSvgDataUrl" />
            </v-tab-item>
            <v-tab-item v-if="!!info?.id && e6>1">
                <Tariffs :id_qr="info.id" :qrtype="'bShop'" />
             </v-tab-item>

          </v-tabs-items>
        </v-col>

        <v-col class="pa-2 px-0" cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-center">
                <div class="col-md-12">
                  <p>{{ $t("stepper.create_qr") }}</p>
                </div>
                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <v-text-field
                    v-model="cardTexts.visitName"
                    :disabled="e6 > 1"
                    append-icon="mdi-pen"
                    class="contentinfo mt-0 pt-0"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    :label="$t('fields.online_store_name')"
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-visitName`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="$t('fields.online_store_name')"
                  />
                </div>

                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <qr-address-field
                    id="qr-address"
                    ref="address-field"
                    v-model="dtUrl"
                    :disabled="e6 > 1"
                    :error-messages="errors['identifier']"
                    append-icon="mdi-web"
                    class="contentinfo mt-0 pt-0"
                    dense
                    :hint="$t('fields.qr_address_hint')"
                    outlined
                    persistent-hint
                    @updateDest="domainId = $event"
                    :key="$t('qrAddressUpdate.hints.allowedChars')"

                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-dtUrl`"
                    :label="$t('fields.qr_address')"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                  />
                </div>
              </div>
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="markQr"
                />
              </div>
            </v-stepper-content>

            <v-stepper-step :complete="e6 > 2" class="px-0 px-md-4" step="2">
              {{ $t("stepper.products_info") }}
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
              <div class="d-flex align-center mb-4">
                <div class="d-flex row mx-2 mt-3 mb-4 justify-start doublebtn">
                  <v-btn
                    :disabled="e6 > 2"
                    color="third"
                    outlined
                    @click="clearDefaults"
                  >
                    <v-icon class="me-2">{{
                      isCleared ? "mdi-restore" : "mdi-delete"
                    }}</v-icon>
                    {{
                      isCleared
                        ? $t("buttons.reset_defaults")
                        : $t("buttons.cleardefaults")
                    }}
                  </v-btn>
                  <help-info
                    :element-name="`${serviceName}-${componentName}-clearDefaults`"
                    :label="
                      isCleared
                        ? $t('buttons.reset_defaults')
                        : $t('buttons.cleardefaults')
                    "
                    :service-name="serviceName"
                    :help-data="helpData"
                  />

                  <v-btn
                    v-if="$i18n.locale === 'fa'"
                    :loading="templateLoading"
                    class="btn-download ma-0"
                    depressed
                    @click="ready = true"
                  >
                    {{ $t("buttons.select_prepared_store") }}
                  </v-btn>
                  <help-info
                    v-if="$i18n.locale === 'fa'"
                    :element-name="`${serviceName}-${componentName}-preparedData`"
                    :label="$t('buttons.select_prepared_store')"
                    :service-name="serviceName"
                    :help-data="helpData"
                  />
                </div>
                <v-spacer />
                <!-- v-if="$i18n.locale === 'fa'" -->
                <v-card-actions class="justify-end">
                  <v-switch
                    v-model="cardTexts.product.onlineShop"
                    class="ma-0"
                    dense
                    hide-details
                    inset
                    :label="$t('fields.online_sale')"
                  />

                </v-card-actions>
              
              </div>
                <div class="mb-4 mx-4">
                  <!-- سوییچ و آیکون راهنما -->
                  <div class="d-flex align-center">
                    <v-switch
                      v-model="AutoSave"
                      color="primary"
                      class="mt-0 pt-0 shrink"
                      hide-details
                      label="ذخیره خودکار"
                    ></v-switch>

                    <!-- آیکون راهنما با Tooltip (هاور برای دسکتاپ و تاچ برای موبایل) -->
                    <v-tooltip bottom max-width="320">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          x-small
                          class="mr-1"
                          v-bind="attrs"
                          v-on="on"
                          @click.stop
                        >
                          <v-icon small color="grey darken-1">
                            mdi-help-circle-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>
                        تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                      </span>
                    </v-tooltip>
                  </div>
                  <div
                    v-if="$vuetify.breakpoint.xsOnly"
                    class="text-caption grey--text text--darken-1 mt-1 pr-1"
                    style="line-height: 1.4"
                  >
                    تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                
                  </div>
                </div>


              <list-expansion
                v-model="cardTexts"
                :components="specialInfo"
                :data="cardTexts"
                :service-name="serviceName"
                :component-name="componentName"
                flat
                @save-required="AutoSave && qrUpdate(false)"
              />

              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="e6 = 3"
                />
              </div>
            </v-stepper-content>

            <v-stepper-step :complete="e6 > 3" class="px-0 px-md-4" step="3">
              {{ $t("stepper.content_settings") }}
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="3">
              <list-expansion
                v-model="cardTexts"
                :components="specialInfo2"
                :data="cardTexts"
                :service-name="serviceName"
                :component-name="componentName"
                flat
                @save-required="AutoSave && qrUpdate(false)"
              />

              <div class="row mx-auto">
                <div class="col-md-6">
                  <prev-btn :loading="loading" @click="e6 = 2" />
                </div>

                <div class="col-md-6">
                  <next-btn
                    :loading="loading"
                    style="background: #1b8d39"
                    @click=" 
                    qrUpdate(true);
                    if (cardTexts.product?.onlineShop){
                    e6++;
                    }else{
                      if (!cardTexts.product || !cardTexts.product?.onlineShop)
                        goto('qr/list');
                    }
                    "
                  />
                </div>
              </div>
            </v-stepper-content>

            <v-stepper-step
              :complete="e6 > 4"
              class="px-0 px-md-4"
              step="4"
              v-if="!!cardTexts.product && cardTexts.product?.onlineShop"
            >
              {{ $t("stepper.sales_settings") }}
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="4">
              <qr-shop-manager ref="qrShop" :qr-id="createdId"
                                @save-required="AutoSave && qrUpdate(false)" />
              <div class="row mx-auto">
                <div class="col-md-6">
                  <prev-btn :loading="loading" @click="e6 = 3" />
                </div>

                <div class="col-md-6">
                  <next-btn :loading="loading" @click="updateShopSettings" />
                </div>
              </div>
            </v-stepper-content>
          </v-stepper>

          <div class="d-none">
            <qr-code-make
              v-if="e6 > 1"
              ref="qrCanvas"
              v-model="qrDesign"
              :file.sync="qrSvgDataUrl"
              :link="fullLink"
              @save="qrDesign = $event"
            />
          </div>
        </v-col>

        <custom-popup
          v-model="showDialog"
          :cons="{ title: $t('download_qr') }"
          hide-confirm
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-show-download-d`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('buttons.download_qr')"
            />
          </template>
          <v-card class="pa-5">
            <download-file-with-api
              v-if="showDialog"
            :address="`${info?.domain?.name||'qrland.in/'}${info?.identifier}`"
            :visit-name="cardTexts.visitName"
            :qr_id="info?.qrId"
            :is-qrlink="['qrlink','clickyarseo'].includes(info?.type?.toLowerCase())"

            />
          </v-card>
        </custom-popup>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import HelpInfo from "../../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import QrAddressField from "@/view/content/fragments/qrAddressField";
import ListExpansion from "@/view/content/fragments/listExpansion";
import NextBtn from "@/view/content/fragments/nextBtn";
import PrevBtn from "@/view/content/fragments/prevBtn";
import QrCustomize from "@/view/pages/qrland/components/qrCustomize";
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement";
import QrMaker from "@/view/pages/qrland/components/qrMaker";
import ViewShop from "./viewShop";
import PreparedCards from "@/view/pages/qrland/preparedCards";
import QrCodeMake from "@/view/pages/qrland/qrCodeStyle/qrCodeMake";
import { mapActions, mapState } from "vuex";
import QrShopManager from "@/view/pages/qrland/components/qrManage/manageShop/qrShopManager.vue";
import StoreShopContent from "@/utilities/StoreShopContent";
import { getLanguageCookie } from "../../../../../core/plugins/TitleRibbon/utils/languageCookie";
import DownloadFileWithApi from "../../../qrland/downloadFileWithApi.vue";
import Tariffs from "../../../../components/Tariffs/Tariffs.vue";
import { AtomSpinner } from "epic-spinners";

export default {
  name: "createShop",

  components: {
    HelpInfo,
    HelpInfoWrapper,
    QrShopManager,
    PreparedCards,
    QrCodeMake,
    ViewShop,
    DownloadFileWithApi,
    QrMaker,
    QrManagement,
    QrCustomize,
    PrevBtn,
    NextBtn,
    ListExpansion,
    QrAddressField,
    Tariffs,
    AtomSpinner
  },

  provide: {
    productImageSize: "128",
  },

  data() {
    const initialCardTexts = {
      language: "fa",
      shopLoginConfig: {
        shopLogo: [
          { value: "logo", logo: "" },
          { value: "background", background: "" },
        ],
        configs: {
          subtitle: "",
        },
      },
      banner: {
        gallery: [
          {
            name: "",
            images: [
              {
                name: "28",
                title: "",
                url: "",
                description: "",
                link: "",
                id: 17534,
              },
              {
                name: "32",
                title: "",
                url: "",
                description: "",
                link: "",
                id: 17535,
              },
            ],
          },
        ],
      },
      consultation: {
        description: "",
        sectionColor: { backGround: "", text: "" },
        // items: {
        //   name: {
        //     is_active: false,
        //     type: "optional",
        //     value: "",
        //     format: "text",
        //   },
        //   surname: {
        //     is_active: false,
        //     type: "optional",
        //     value: "",
        //     format: "text",
        //   },
        //   phone: {
        //     is_active: false,
        //     type: "optional",
        //     value: "",
        //     format: "number",
        //   },
        //   mail: {
        //     is_active: false,
        //     type: "optional",
        //     value: "",
        //     format: "text",
        //   },
        //   address: {
        //     is_active: false,
        //     type: "optional",
        //     value: "",
        //     format: "text",
        //   },
        //   nationalId: {
        //     is_active: false,
        //     type: "optional",
        //     value: "",
        //     format: "number",
        //     verify: "correct",
        //   },
        //   location: {
        //     is_active: false,
        //     type: "optional",
        //     value: "",
        //     format: "text",
        //   },
        //   custom: {
        //     is_active: false,
        //     type: "optional",
        //     value: "",
        //     format: "select",
        //     extra: { label: "", options: [] },
        //   },
        //   description: {
        //     is_active: false,
        //     type: "optional",
        //     value: "",
        //     format: "text",
        //   },
        // },
      },
      photoSlider: false,
      gallerySlider: false,
      isGradient: false,
      personnel: { items: [] },
      WorkSheet: {
        items: {
          saturday: {
            shift: [
              { start: "08:00", end: "14:00" },
              { start: "17:00", end: "21:00" },
            ],
            start: "08:00:00",
            end: "22:00:00",
          },
          sunday: {
            shift: [
              { start: "08:00", end: "14:00" },
              { start: "17:00", end: "21:00" },
            ],
            start: "08:00:00",
            end: "22:00:00",
          },
          monday: {
            shift: [
              { start: "08:00", end: "14:00" },
              { start: "17:00", end: "21:00" },
            ],
            start: "08:00:00",
            end: "22:00:00",
          },
          tuesday: {
            shift: [
              { start: "08:00", end: "14:00" },
              { start: "17:00", end: "21:00" },
            ],
            start: "08:00:00",
            end: "22:00:00",
          },
          wednesday: {
            shift: [
              { start: "08:00", end: "14:00" },
              { start: "17:00", end: "21:00" },
            ],
            start: "08:00:00",
            end: "22:00:00",
          },
          thursday: {
            shift: [{ start: "08:00", end: "12:00" }, {}],
            start: "08:00:00",
            end: "22:00:00",
          },
          friday: { shift: [{}, {}] },
        },
      },
      Counter: { until: "2026-03-21 00:00:00", type: "countdown_2" },
      product: {
        description: "",
        sectionColor: {
          backGround: "linear-gradient(to right , #350808, #1C107CFF)",
          text: "#fff",
        },
        items: [],
        onlineShop: true,
      },
      specialCategories: {
        description: "",
        sectionColor: {
          backGround: "linear-gradient(to right , #350808, #1C107CFF)",
          text: "#fff",
        },
        items: [],
      },
      visitName: "",
      organizationName: "",
      subOrgan: "",
      userName: "",
      workField: "",
      phoneNumber: [
        { number: "90007425" },
        { number: "02191017077" },
        { number: "09999903535" },
      ],
      extraFields: [
        { icon: "", name: "", value: "" },
        {
          icon: "mdi-chevron-triple-left",
          name: "",
          value: "",
          link: "www.divar.ir",
        },
        {
          icon: "mdi-chevron-triple-left",
          name: "",
          value: "",
          link: "www.digikala.com",
        },
        {
          icon: "mdi-chevron-triple-left",
          name: "",
          value: "",
          link: "www.basalam.com",
        },
        {
          icon: "mdi-chevron-triple-left",
          name: "",
          value: "",
          link: "www.torob.com",
        },
        {
          icon: "mdi-chevron-triple-left",
          name: "",
          value: "",
          link: "www.emalls.ir",
        },
      ],
      companyNumber: "02191017077",
      email: "9100terminalads@gmail.com",
      fax: "02191016066",
      location: "",
      city: "",
      codePostal: "1541946815",
      province: "",
      country: "",
      website: "www.terminalads.com",
      socialMedia: {
        address: [
          {
            label: "",
            text: "",
            pattern: "",
            prefix: "URL",
            url: "qrland.ir",
            img: "/media/socialIcon/40icon/location.svg",
            svg: "svgLocation",
          },
        ],
        instagram: [
          {
            label: "",
            text: "",
            pattern: "https://instagram.com/",
            prefix: "@",
            url: "terminalads",
            img: "/media/socialIcon/40icon/instagram.svg",
            svg: "svgInstagram",
          },
        ],
        whatsapp: [
          {
            label: "",
            text: "",
            pattern: "https://wa.me/",
            prefix: "mdi-phone",
            url: "+982191017077",
            img: "/media/socialIcon/40icon/whatsapp.svg",
            svg: "svgWhatsapp",
          },
        ],
      },
      aboutUs: "",
      copyright: "",
      center: [51.420296, 35.732379],
      coordinates: [51.420296, 35.732379],
      address: "",
      pallete: {},
      textCards: {
        sectionColor: {
          backGround: "linear-gradient(to bottom , #C22121FF, #130000FF)",
          text: "#fff",
        },
      },
      pdfSelector: {
        description: "",
        sectionColor: { backGround: "", text: "" },
        slider: false,
        layout: "list",
      },
      Blog: {
        description: null,
        slide: true,
        sectionColor: { backGround: "", text: "" },
        slider: true,
      },
      CounterService: {
        description: "",
        sectionColor: { backGround: "", text: "" },
        items: [
          { type: "percent", counter: "97", icon: "mdi-account", link: "" },
          {
            type: "percent",
            counter: "4",
            icon: "mdi-backup-restore",
            link: "",
          },
          {
            type: "number",
            counter: "20000",
            icon: "mdi-account-box-multiple",
            link: "",
          },
          {
            type: "number",
            counter: "145485",
            icon: "mdi-archive-check",
            link: "",
          },
        ],
      },
      PicSelector: {
        description: null,
        sectionColor: { backGround: "", text: "" },
        slider: true,
      },
      VideoGallery: {
        description: "",
        sectionColor: { backGround: "", text: "" },
      },
      ServiceSection: {
        description: "",
        sectionColor: { backGround: "", text: "" },
        items: [
          {
            section: {
              title: "",
              text: null,
              button: {
                show: false,
                title: "",
                icon: "mdi-monitor-cellphone",
                background: "linear-gradient(to right , #1AD0D8FF, #2115A7FF)",
                color: "#ffffffff",
                link: "https://my.qrland.ir/003#/",
                target: "_blank",
              },
              text_position: "left",
              object: {
                type: "image",
                url: "",
              },
            },
          },
        ],
      },
      faq: {
        description: "",
        design: { gallery: [{ name: "", images: [] }] },
        sectionColor: {
          backGround: "linear-gradient(to right , #FF000062, #FF000075)",
          text: "#fff",
        },
        items: [
          { question: "", answer: "" },
          { question: "", answer: "" },
          { question: "", answer: "" },
          { question: "", answer: "" },
          { question: "", answer: "" },
        ],
      },
      Service: {
        slider: false,
        description: null,
        sectionColor: { backGround: "", text: "" },
      },
      FeedBack: {
        description: "",
        sectionColor: { backGround: "", text: "" },
        type: "emoji",
        items: [
          {
            question: "",
            type: "emoji",
            answer: "",
            value: null,
            description: true,
            forceDesc: false,
          },
          {
            question: "",
            type: "emoji",
            answer: "",
            value: null,
            description: false,
            forceDesc: false,
          },
          {
            question: "",
            type: "emoji",
            answer: "",
            value: null,
            description: false,
            forceDesc: false,
          },
          {
            question: "",
            type: "emoji",
            answer: "",
            value: null,
            description: false,
            forceDesc: false,
          },
          {
            question: "",
            type: "emoji",
            answer: "",
            value: null,
            description: true,
            forceDesc: true,
          },
        ],
      },
      apiKey:
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
      pdf: [
        {
          name: "گالری پروپزال‌های کیوآرلند",
          images: [
            {
              title: "پروپزال معرفی محصول",
              link: "https://cdn.terminalads.com/%D9%BE%D8%B1%D9%88%D9%BE%D8%B2%D8%A7%D9%84%20%DA%A9%DB%8C%D9%88%D8%A2%D8%B1%DA%A9%D8%AF%20%D9%85%D8%B9%D8%B1%D9%81%DB%8C%20%D9%85%D8%AD%D8%B5%D9%88%D9%84.pdf",
              url: "media/productpro.webp",
              description:
                "معرفی کامل سرویس‌های کیوآرلند، نحوه کار QR کدهای هوشمند، مزایا برای کسب‌وکارها و نمونه کاربردها برای افزایش تعامل مشتریان.",
              selected: true,
            },
            {
              title: "پروپزال کارت ویزیت الکترونیکی",
              link: "https://cdn.terminalads.com/%D9%BE%D8%B1%D9%88%D9%BE%D9%88%D8%B2%D8%A7%D9%84%20%DA%A9%D8%A7%D8%B1%D8%AA%20%D9%88%DB%8C%D8%B2%DB%8C%D8%AA%20%D8%A7%D9%84%DA%A9%D8%AA%D8%B1%D9%88%D9%86%DB%8C%DA%A9%DB%8C.pdf",
              url: "media/cardvisit.webp",
              description:
                "معرفی کارت ویزیت دیجیتال کیوآرلند، امکانات اشتراک سریع اطلاعات تماس، لینک شبکه‌های اجتماعی و مدیریت حرفه‌ای ارتباط با مشتریان.",
              selected: true,
            },
          ],
        },
      ],
      blog: [],
      service: [
        {
          content: "",
          icon: "mdi-truck-fast",
          gallery: [{ name: "", images: [] }],
          color: null,
        },
        {
          content: "",
          icon: "mdi-account-credit-card",
          gallery: [{ name: "", images: [] }],
          color: null,
        },
        {
          content: "",
          icon: "mdi-shield-check",
          gallery: [{ name: "", images: [] }],
          color: null,
        },
      ],
      gallery: [
        {
          name: "",
          images: [
            {
              name: "34",
              title: "",
              url: "",
              description: "",
              link: "",
              id: 17536,
            },
            {
              name: "35",
              title: "",
              url: "",
              description: "",
              link: "",
              id: 17537,
            },
            {
              name: "36",
              title: "",
              url: "",
              description: "",
              link: "",
              id: 17538,
            },
          ],
        },
      ],
      video_gallery: [
        {
          name: "",
          images: [
            {
              name: "",
              title: "",
              file_link:
                "https://persian7.asset.aparat.com/aparat-video/1d2d2d8b5fea10b3cbda4fb6e2c45c7653042587-1080p.apt?wmsAuthSign=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjFmMmE5MjgyOWMyZjEzOGNkZmRlMWFlOGU2MzJmNGQxIiwiZXhwIjoxNzE4NDMzMjQ1LCJpc3MiOiJTYWJhIElkZWEgR1NJRyJ9.su36sCl2UH54sLhnn78_dHggUySs2d0CKGs3vW5UTH8",
              description: "",
              link: "",
              id: 15,
            },
          ],
        },
      ],
    };

    return {
      AutoSave:false,
      isAutoSaving: false, 
      svgMade: "",
      cardTexts: JSON.parse(JSON.stringify(initialCardTexts)),
      initialCardTexts,
      isCleared: false,
      helpData: [],
      serviceName: "Qrland",
      componentName: "createShop",
      qrDesign: {},
      e6: 1,
      ready: false,
      errors: {},
      createdDomain: null,
      createdId: null,
      info: null,
      loading: false,
      templateLoading: false,
      showDialog: false,
      dtUrl: null,
      domainId: "",
      qrShow: 1,
      qrSvgDataUrl: "",
      specialInfo: [
        {
          name: "shopLoginConfig",
          value: "",
          title: "",
          subtitle: "",
          icon: "home-import-outline",
          model: "shopLoginConfig",
          tabs: [
            {
              title: "",
              icon: "mdi-cards-playing-heart-outline",
              component: "shopLogo",
              model: "shopLogo",
            },
            {
              title: "",
              icon: "mdi-view-carousel-outline",
              component: "shopLoginConfig",
              model: "configs",
            },
          ],
        },
        {
          name: "bannerSelector",
          value: "",
          title: "",
          subtitle: "",
          icon: "image",
          model: "banner",
        },
        {
          name: "textCards",
          value: "",
          title: "",
          subtitle: "",
          icon: "account-outline",
        },
        {
          name: "Product",
          value: "",
          title: "",
          subtitle: "",
          icon: "sign-yield",
          model: "product",
          arm: [],
        },
        {
          name: "specialCategoryManager",
          value: "",
          title: "",
          subtitle: "",
          icon: "star-box-outline",
          model: "specialCategories",
        },
        {
          name: "socialMediaIcons",
          value: "",
          title: "",
          subtitle: "",
          icon: "instagram",
          model: "socialMedia",
        },
        {
          name: "Blog",
          value: "",
          title: "",
          subtitle: "",
          icon: "text",
        },
        {
          name: "Service",
          value: "",
          title: "",
          subtitle: "",
          icon: "toolbox-outline",
        },
        {
          name: "Faq",
          value: "",
          title: "",
          subtitle: "",
          icon: "help",
          model: "faq",
        },
      ],
      specialInfo2: [
        {
          name: "PicSelector",
          value: "",
          title: "",
          subtitle: "",
          icon: "image",
        },
        {
          name: "VideoGallery",
          value: "",
          title: "",
          subtitle: "",
          icon: "video",
        },
        {
          name: "pdfSelector",
          value: "",
          title: "",
          subtitle: "",
          icon: "file",
        },
        {
          name: "FeedBack",
          value: "",
          title: "",
          subtitle: "",
          icon: "reply",
          model: "FeedBack",
        },
        {
          name: "Counter",
          value: "",
          title: "",
          subtitle: "",
          icon: "timer",
          model: "Counter",
        },
        {
          name: "consultation",
          value: "",
          title: "",
          subtitle: "",
          icon: "list-box-outline",
          model: "consultation",
        },
        {
          name: "ServiceSection",
          value: "",
          title: "",
          subtitle: "",
          icon: "post",
          model: "ServiceSection",
        },
        {
          name: "CounterService",
          value: "",
          title: "",
          subtitle: "",
          icon: "post",
          model: "CounterService",
        },
        {
          name: "Personnel",
          value: "",
          title: "",
          subtitle: "",
          icon: "account-multiple",
          model: "personnel",
        },
        {
          name: "WorkSheet",
          value: "",
          title: "",
          subtitle: "",
          icon: "timer",
          model: "WorkSheet",
        },
      ],
    };
  },

  mounted() {
    this.cardTexts.socialMedia = {
      address: [
        {
          label: this.$t("address"),
          text: this.$t("enter_site_link"),
          pattern: "",
          prefix: "URL",
          url: "qrland.ir",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
        {
          label: this.$t("address"),
          text: this.$t("enter_site_link"),
          pattern: "",
          prefix: "URL",
          url: "qr.terminalads.com",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
      ],
      instagram: [
        {
          label: this.$t("instagram"),
          text: this.$t("enter_instagram_username"),
          pattern: "https://instagram.com/",
          prefix: "@",
          url: "terminalads",
          img: "/media/socialIcon/40icon/instagram.svg",
          svg: "svgInstagram",
        },
      ],
      whatsapp: [
        {
          label: this.$t("whatsapp"),
          text: this.$t("enter_whatsapp_address"),
          pattern: "https://wa.me/",
          prefix: "mdi-phone",
          url: "+982191017077",
          img: "/media/socialIcon/40icon/whatsapp.svg",
          svg: "svgWhatsapp",
        },
      ],
    };
    this.$nextTick(() => {
      const url = this.roboatUrl;

      this.cardTexts.banner.gallery[0].images[0].url = `${url}/upload/6676afc9ddf26.webp`;
      this.cardTexts.banner.gallery[0].images[1].url = `${url}/upload/6676afd1cdc70.webp`;

      this.cardTexts.ServiceSection.items[0].section.object.url = `${url}/upload/666d5c59898ed.webp`;

      this.cardTexts.gallery[0].images[0].url = `${url}/upload/6676afd6ecb43.webp`;
      this.cardTexts.gallery[0].images[1].url = `${url}/upload/6676afdcdc7cb.webp`;
      this.cardTexts.gallery[0].images[2].url = `${url}/upload/6676afe735707.webp`;
    });
    const savedLanguage = getLanguageCookie() || "fa";
    this.$i18n.locale = savedLanguage;
    this.$nextTick(() => {
      this.updateTransition();
    });
  },

  computed: {
    ...mapState("localstorage", ["createQrID"]),
    ...mapState("local", ["identifier", "domain", "qr_id", "qrInfo"]),
    roboatUrl() {
      return this.$roboatUrl || "";
    },
    fullLink() {
      return this.createdDomain?.replace("/", "") + "/" + this.createdId;
    },
  },

  watch: {
    "$i18n.locale": {
      handler(newLocale) {
        this.updateTransition();
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID", "setQrType"]),
    ...mapActions("local", [
      "updateQrId",
      "updateQridentifier",
      "updateQrInfo",
      "updateQrDomain",
    ]),

    updateTransition() {
      try {
        this.$set(this.specialInfo[0], "title", this.$t("login_settings"));
        this.$set(
          this.specialInfo[0].tabs[0],
          "title",
          this.$t("shop_logo_and_images"),
        );
        this.$set(
          this.specialInfo[0].tabs[1],
          "title",
          this.$t("login_page_info"),
        );
        this.$set(this.specialInfo[1], "title", this.$t("upload_banner"));
        this.$set(this.specialInfo[2], "title", this.$t("user_info"));
        this.$set(this.specialInfo[3], "title", this.$t("create_product"));
        this.$set(this.specialInfo[4], "title", this.$t("special_sale"));
        this.$set(this.specialInfo[5], "title", this.$t("add_social_networks"));
        this.$set(this.specialInfo[6], "title", this.$t("blog"));
        this.$set(this.specialInfo[7], "title", this.$t("services"));
        this.$set(this.specialInfo[8], "title", this.$t("faq"));
        this.$set(this.specialInfo2[0], "title", this.$t("shop.photo_gallery"));
        this.$set(this.specialInfo2[1], "title", this.$t("shop.video_gallery"));
        this.$set(this.specialInfo2[2], "title", this.$t("shop.pdf_gallery"));
        this.$set(this.specialInfo2[3], "title", this.$t("shop.feedback"));
        this.$set(this.specialInfo2[4], "title", this.$t("shop.countdown"));
        this.$set(this.specialInfo2[5], "title", this.$t("shop.request_form"));
        this.$set(this.specialInfo2[6], "title", this.$t("shop.create_section"));
        this.$set(this.specialInfo2[7], "title", this.$t("shop.achievements"));
        this.$set(this.specialInfo2[8], "title", this.$t("shop.team_members"));
        this.$set(this.specialInfo2[9], "title", this.$t("shop.working_hours"));
        this.$set(
          this.cardTexts.shopLoginConfig.shopLogo[0],
          "logo",
          this.$t("default_logo"),
        );
        this.$set(
          this.cardTexts.shopLoginConfig.shopLogo[1],
          "background",
          this.$t("background_image"),
        );
        this.$set(
          this.cardTexts.consultation,
          "title",
          this.$t("request_form"),
        );
        // this.$set(
        //   this.cardTexts.consultation.items.name,
        //   "persian",
        //   this.$t("name_field")
        // );
        // this.$set(
        //   this.cardTexts.consultation.items.surname,
        //   "persian",
        //   this.$t("family_name")
        // );
        // this.$set(
        //   this.cardTexts.consultation.items.phone,
        //   "persian",
        //   this.$t("mobile_number")
        // );
        // this.$set(
        //   this.cardTexts.consultation.items.mail,
        //   "persian",
        //   this.$t("email")
        // );
        // this.$set(
        //   this.cardTexts.consultation.items.address,
        //   "persian",
        //   this.$t("address_label")
        // );
        // this.$set(
        //   this.cardTexts.consultation.items.nationalId,
        //   "persian",
        //   this.$t("national_code")
        // );
        // this.$set(
        //   this.cardTexts.consultation.items.location,
        //   "persian",
        //   this.$t("location_label")
        // );
        // this.$set(
        //   this.cardTexts.consultation.items.description,
        //   "persian",
        //   this.$t("description")
        // );
        this.$set(this.cardTexts.Counter, "title", this.$t("shop.countdown"));
        this.$set(
          this.cardTexts.Counter,
          "description",
          this.$t("striving_for_excellence"),
        );
        this.$set(this.cardTexts.product, "title", this.$t("products"));
        this.$set(
          this.cardTexts.specialCategories,
          "title",
          this.$t("special_sale"),
        );
        this.$set(this.cardTexts, "organizationName", this.$t("qrland"));
        this.$set(
          this.cardTexts,
          "subOrgan",
          this.$t("online_store_ready_15_minutes"),
        );
        this.$set(this.cardTexts, "userName", this.$t("mrs_Safdarian"));
        this.$set(this.cardTexts, "workField", this.$t("sales_management"));
        this.$set(
          this.cardTexts.extraFields[0],
          "value",
          this.$t("dear_customer_online_stores"),
        );
        this.$set(
          this.cardTexts.extraFields[1],
          "value",
          this.$t("divar_site"),
        );
        this.$set(
          this.cardTexts.extraFields[2],
          "value",
          this.$t("digikala_site"),
        );
        this.$set(
          this.cardTexts.extraFields[3],
          "value",
          this.$t("basalam_site"),
        );
        this.$set(
          this.cardTexts.extraFields[4],
          "value",
          this.$t("torob_site"),
        );
        this.$set(
          this.cardTexts.extraFields[5],
          "value",
          this.$t("emalls_site"),
        );
        this.$set(this.cardTexts, "location", this.$t("tehran_address"));
        this.$set(this.cardTexts, "aboutUs", this.$t("about_us"));
        this.$set(this.cardTexts, "copyright", this.$t("copyright_qrland"));
        this.$set(
          this.cardTexts.CounterService,
          "title",
          this.$t("our_achievements"),
        );
        this.$set(
          this.cardTexts.CounterService.items[0],
          "name",
          this.$t("customer_satisfaction"),
        );
        this.$set(
          this.cardTexts.CounterService.items[1],
          "name",
          this.$t("lowest_returns"),
        );
        this.$set(
          this.cardTexts.CounterService.items[2],
          "name",
          this.$t("loyal_customer"),
        );
        this.$set(
          this.cardTexts.CounterService.items[3],
          "name",
          this.$t("shipped_orders"),
        );
        this.$set(
          this.cardTexts.VideoGallery,
          "title",
          this.$t("video_gallery"),
        );
        this.$set(
          this.cardTexts.VideoGallery,
          "description",
          this.$t("visit_our_videos"),
        );
        this.$set(
          this.cardTexts.ServiceSection.items[0].section.button,
          "title",
          this.$t("comfortable_purchase"),
        );
        this.$set(this.cardTexts.faq, "title", this.$t("faq"));
        this.$set(this.cardTexts.faq, "description", this.$t("description"));
        this.$set(
          this.cardTexts.faq.design.gallery[0],
          "name",
          this.$t("photo_gallery"),
        );
        this.$set(
          this.cardTexts.faq.items[0],
          "question",
          this.$t("how_to_place_order"),
        );
        this.$set(
          this.cardTexts.faq.items[0],
          "answer",
          this.$t("add_to_cart"),
        );
        this.$set(
          this.cardTexts.faq.items[1],
          "question",
          this.$t("how_to_register"),
        );
        this.$set(
          this.cardTexts.faq.items[1],
          "answer",
          this.$t("click_login_and_enter_code"),
        );
        this.$set(
          this.cardTexts.faq.items[2],
          "question",
          this.$t("delivery_time"),
        );
        this.$set(
          this.cardTexts.faq.items[2],
          "answer",
          this.$t("fastest_delivery"),
        );
        this.$set(
          this.cardTexts.faq.items[3],
          "question",
          this.$t("shipping_cost"),
        );
        this.$set(
          this.cardTexts.faq.items[3],
          "answer",
          this.$t("variable_shipping_cost"),
        );
        this.$set(
          this.cardTexts.faq.items[4],
          "question",
          this.$t("change_or_cancel_order"),
        );
        this.$set(
          this.cardTexts.faq.items[4],
          "answer",
          this.$t("no_change_or_cancel"),
        );
        this.$set(
          this.cardTexts.Service,
          "title",
          this.$t("bringing_the_best"),
        );
        this.$set(
          this.cardTexts.FeedBack,
          "title",
          this.$t("feedback_important"),
        );
        this.$set(
          this.cardTexts.FeedBack,
          "description",
          this.$t("guide_us_with_feedback"),
        );
        this.$set(
          this.cardTexts.FeedBack.items[0],
          "question",
          this.$t("satisfied_with_quality"),
        );
        this.$set(
          this.cardTexts.FeedBack.items[1],
          "question",
          this.$t("evaluate_packaging_quality"),
        );
        this.$set(
          this.cardTexts.FeedBack.items[2],
          "question",
          this.$t("satisfied_with_variety"),
        );
        this.$set(
          this.cardTexts.FeedBack.items[3],
          "question",
          this.$t("benefited_from_discounts"),
        );
        this.$set(
          this.cardTexts.FeedBack.items[4],
          "question",
          this.$t("suggestions_for_improvement"),
        );
        this.$set(this.cardTexts.service[0], "title", this.$t("post_1"));
        this.$set(
          this.cardTexts.service[0],
          "content",
          this.$t("fast_order_delivery"),
        );
        this.$set(this.cardTexts.service[1], "title", this.$t("post_2"));
        this.$set(
          this.cardTexts.service[1],
          "content",
          this.$t("cash_on_delivery"),
        );
        this.$set(this.cardTexts.service[2], "title", this.$t("post_3"));
        this.$set(
          this.cardTexts.service[2],
          "content",
          this.$t("product_authenticity_guarantee"),
        );
        this.$set(this.cardTexts.gallery[0], "name", this.$t("photo_gallery"));
        this.$set(this.cardTexts.video_gallery[0], "name", this.$t("gallery"));
        this.$set(
          this.cardTexts.video_gallery[0].images[0],
          "name",
          this.$t("welcome"),
        );
        this.$set(
          this.cardTexts.WorkSheet.items.saturday,
          "name",
          this.$t("saturday"),
        );
        this.$set(
          this.cardTexts.WorkSheet.items.sunday,
          "name",
          this.$t("sunday"),
        );
        this.$set(
          this.cardTexts.WorkSheet.items.monday,
          "name",
          this.$t("monday"),
        );
        this.$set(
          this.cardTexts.WorkSheet.items.tuesday,
          "name",
          this.$t("tuesday"),
        );
        this.$set(
          this.cardTexts.WorkSheet.items.wednesday,
          "name",
          this.$t("wednesday"),
        );
        this.$set(
          this.cardTexts.WorkSheet.items.thursday,
          "name",
          this.$t("thursday"),
        );
        this.$set(
          this.cardTexts.WorkSheet.items.friday,
          "name",
          this.$t("friday"),
        );

        this.cardTexts.socialMedia = {
          address: [
            {
              label: this.$t("address"),
              text: this.$t("enter_site_link"),
              pattern: "",
              prefix: "URL",
              url: "qrland.ir",
              img: "/media/socialIcon/40icon/location.svg",
              svg: "svgLocation",
            },
            {
              label: this.$t("address"),
              text: this.$t("enter_site_link"),
              pattern: "",
              prefix: "URL",
              url: "qr.terminalads.com",
              img: "/media/socialIcon/40icon/location.svg",
              svg: "svgLocation",
            },
          ],
          instagram: [
            {
              label: this.$t("instagram"),
              text: this.$t("enter_instagram_username"),
              pattern: "https://instagram.com/",
              prefix: "@",
              url: "terminalads",
              img: "/media/socialIcon/40icon/instagram.svg",
              svg: "svgInstagram",
            },
          ],
          whatsapp: [
            {
              label: this.$t("whatsapp"),
              text: this.$t("enter_whatsapp_address"),
              pattern: "https://wa.me/",
              prefix: "mdi-phone",
              url: "+982191017077",
              img: "/media/socialIcon/40icon/whatsapp.svg",
              svg: "svgWhatsapp",
            },
          ],
        };
      } catch (er) {
        console.error("Error in updateTransition:", er);
      }
    },

    markQr() {
      if (
        !this.dtUrl ||
        typeof this.$refs["address-field"].dtUrlRule(this.dtUrl) !== "boolean"
      ) {
        this.$toast.clear();
        this.$toast.error("آدرس وارد شده صحیح نمی‌باشد!");
        return;
      }

      this.loading = true;
      let obj = {
        type: "bShop",
        qrType: "dynamic",
        title: this.cardTexts.visitName,
        domain_id: this.domainId,
        data: JSON.stringify({
          theme: "",
          data: this.cardTexts,
        }),
        qr: JSON.stringify(this.qrDesign),
      };
      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }
      this.$api
        .post("/v1/testQr/store", obj)
        .then(({ data }) => {
          this.loading = false;
          this.info = data.data;
          this.updateQrInfo(this.info);

          this.createdDomain = this.$refs["address-field"].destItems.find(
            (item) => item.id === this.domainId,
          ).name;
          this.updateQrDomain(this.createDomain);

          this.createdId = data.data.identifier;
          this.updateQridentifier(data.data.identifier);

          this.$toast.success(this.$t("shop_page_created_success"));
          this.setCreatedQrID(data.data.id);

          this.updateQrId(data.data.id);

          this.setQrType("bShop");
          if (this.e6 === 1) {
            this.e6 = 2;
            this.qrShow =0;
            this.$nextTick(() => {
              setTimeout(() => {
                this.$refs.qrCanvas.appendCanvas(data.data.link);
              }, 700);
              setTimeout(() => {
                this.qrUpdate(false);
                this.qrShow = 1;
              }, 2000);
            });
            this.$refs.qrShop.handleQrType();
          }
        })
        .catch((error) => {
          const response = error.response;
          if (response.status === 422)
            this.$modal.error("خطا", response.data.message);
          const errorMap = {
            "The آدرس کیوآر has already been taken.": "errors.qr_address_taken",
          };

          const translatedErrors = {};

          if (response?.data?.errors) {
            const backendErrors = response.data.errors;

            Object.entries(backendErrors).forEach(
              ([fieldKey, fieldMessages]) => {
                try {
                  translatedErrors[fieldKey] = fieldMessages.map((msg) => {
                    const key = errorMap[msg];
                    return key ? this.$t(key) : msg;
                  });

                  const msg = fieldMessages[0];
                  const key = errorMap[msg];
                  this.$toast.error(key ? this.$t(key) : msg, {
                    timeout: 3000,
                  });
                } catch (e) {
                  console.log("Error in mapping translation: ", e);
                }
              },
            );

            this.errors = translatedErrors;
          } else {
            this.$toast.error(this.$t("qr_creation_failed"));
          }

          let el = document.getElementById("qr-address");
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    qrUpdate(final = false) {
       if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }
      this.loading = true;
      this.cardTexts.product.items = [];
      const data = new FormData();
      data.append("type", "bShop");
      data.append("image", this.qrSvgDataUrl);
      data.append("qrType", "dynamic");
      data.append("domain", this.createdDomain);
      data.append("identifier", this.createdId || "");
      data.append("qr_id", this.info.qrId);
      data.append("_method", "PUT");
      this.cardTexts.language = getLanguageCookie()
        ? getLanguageCookie()
        : "fa";

      data.append(
        "data",
        JSON.stringify({
          theme: "",
          data: this.cardTexts,
        }),
      );
      data.append("qr", JSON.stringify(this.qrDesign));
      this.$api
        .post("/v1/testQr/update", data)
        .then((res) => {
          if(final || !this.isAutoSaving)
          this.$toast.success(this.$t("qr_card_updated_success"));
        })
        .catch((err) => {
          this.$toast.error(this.$t("qr_save_edit_failed"));
        })
        .finally(() => {
          this.loading = false;
          this.isAutoSaving= false;
        });
    },

    updateShopSettings() {
      this.loading = true;
      this.$refs.qrShop.setCartSetting().finally(() => {
        this.loading = false;
        this.goto("qr/list");
      });
    },

    clearDefaults() {
      if (!this.isCleared) {
        // پاک کردن مقادیر
        this.cardTexts = {
          language: this.$i18n.locale || "fa",
          shopLoginConfig: {
            shopLogo: [
              { value: "logo", logo: "" },
              { value: "background", background: "" },
            ],
            configs: { subtitle: "" },
          },
          banner: { gallery: [] },
          consultation: {
            description: "",
            sectionColor: { backGround: "", text: "" },
            items: {
              name: {
                is_active: false,
                type: "optional",
                value: "",
                format: "text",
              },
              surname: {
                is_active: false,
                type: "optional",
                value: "",
                format: "text",
              },
              phone: {
                is_active: false,
                type: "optional",
                value: "",
                format: "number",
              },
              mail: {
                is_active: false,
                type: "optional",
                value: "",
                format: "text",
              },
              address: {
                is_active: false,
                type: "optional",
                value: "",
                format: "text",
              },
              nationalId: {
                is_active: false,
                type: "optional",
                value: "",
                format: "number",
                verify: "correct",
              },
              location: {
                is_active: false,
                type: "optional",
                value: "",
                format: "text",
              },
              custom: {
                is_active: false,
                type: "optional",
                value: "",
                format: "select",
                extra: { label: "", options: [] },
              },
              description: {
                is_active: false,
                type: "optional",
                value: "",
                format: "text",
              },
            },
          },
          photoSlider: false,
          gallerySlider: false,
          isGradient: false,
          personnel: { items: [] },
          WorkSheet: {
            items: {
              saturday: { shift: [], start: "", end: "" },
              sunday: { shift: [], start: "", end: "" },
              monday: { shift: [], start: "", end: "" },
              tuesday: { shift: [], start: "", end: "" },
              wednesday: { shift: [], start: "", end: "" },
              thursday: { shift: [], start: "", end: "" },
              friday: { shift: [], start: "", end: "" },
            },
          },
          Counter: { until: "", type: "" },
          product: {
            description: "",
            sectionColor: { backGround: "", text: "" },
            items: [],
            onlineShop: true,
          },
          specialCategories: {
            description: "",
            sectionColor: { backGround: "", text: "" },
            items: [],
          },
          visitName: "",
          organizationName: "",
          subOrgan: "",
          userName: "",
          workField: "",
          phoneNumber: [],
          extraFields: [],
          companyNumber: "",
          email: "",
          fax: "",
          location: "",
          city: "",
          codePostal: "",
          province: "",
          country: "",
          website: "",
          socialMedia: { address: [], instagram: [], whatsapp: [] },
          aboutUs: "",
          copyright: "",
          center: [51.420296, 35.732379],
          coordinates: [51.420296, 35.732379],
          address: "",
          pallete: {},
          textCards: { sectionColor: { backGround: "", text: "" } },
          pdfSelector: {
            description: "",
            sectionColor: { backGround: "", text: "" },
            slider: false,
            layout: "list",
          },
          Blog: {
            description: "",
            slide: false,
            sectionColor: { backGround: "", text: "" },
            slider: false,
          },
          CounterService: {
            description: "",
            sectionColor: { backGround: "", text: "" },
            items: [],
          },
          PicSelector: {
            description: "",
            sectionColor: { backGround: "", text: "" },
            slider: false,
          },
          VideoGallery: {
            description: "",
            sectionColor: { backGround: "", text: "" },
          },
          ServiceSection: {
            description: "",
            sectionColor: { backGround: "", text: "" },
            items: [],
          },
          faq: {
            description: "",
            design: { gallery: [] },
            sectionColor: { backGround: "", text: "" },
            items: [],
          },
          Service: {
            slider: false,
            description: "",
            sectionColor: { backGround: "", text: "" },
          },
          FeedBack: {
            description: "",
            sectionColor: { backGround: "", text: "" },
            type: "",
            items: [],
          },
          apiKey: "",
          pdf: null,
          blog: [],
          service: [],
          gallery: [],
          video_gallery: [],
        };
        this.isCleared = true;
        this.$toast.success(this.$t("defaults_cleared_success"));
      } else {
        this.cardTexts = JSON.parse(JSON.stringify(this.initialCardTexts));
        this.isCleared = false;
        this.$toast.success(this.$t("defaults_reset_success"));
      }
      this.updateTransition();
      this.$forceUpdate();
    },

    savePageTemplate(input) {
      this.templateLoading = true;
      this.$modal.showLoading(this.$t("wait_for_default_products"));
      const ssc = new StoreShopContent(this.createQrID);
      ssc
        .storeCategories(input.product.items)
        .then((data) => {
          this.$toast.success(this.$t("template_categories_saved"));
          ssc
            .storeProductFromTemplateModel(data.data, input.product.items)
            .then((data) => {
              this.$root.$emit("fetchCategories");
              this.$root.$emit("openCategoryPanel");
              this.$toast.success(this.$t("template_products_saved"));
            })
            .catch((err) => {
              this.$toast.error(this.$t("template_products_save_failed"));
            })
            .finally(() => {
              this.$modal.hideLoading();
              this.templateLoading = false;
            });
        })
        .catch((err) => {
          this.$toast.error(this.$t("template_categories_save_failed"));
        })
        .finally(() => {
          let obj = { ...input };
          obj.product.items = [];
          this.cardTexts = { ...obj };
          this.updateTransition();
        });
    },
  },

  beforeDestroy() {
    this.setCreatedQrID(null);
    this.setQrType(null);
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}
</style>
